import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';
import { ICompanyUser } from 'types';

import { IExchangeSettings, IExchangeSettingsUser } from '../types/exchange-settings.type';

export interface ExchangeSettingsInitialState extends BaseDataReducerV2InitialState<any> {
  settings: IExchangeSettings | null;
  isSaveInitiated: number | null;
  companyUsers: ICompanyUser[];
  availableSigners: IExchangeSettingsUser[];
}

const { initialState, AC, reducer } = basedDataReducerV2<any, ExchangeSettingsInitialState>('exchange-settings');

const exchangeSettingsInitialState: ExchangeSettingsInitialState = {
  ...initialState,
  settings: null,
  isSaveInitiated: 0,
  companyUsers: [],
  availableSigners: [],
};

export const exchangeSettings = createSlice({
  name: 'exchangeSettings',
  initialState: exchangeSettingsInitialState,
  reducers: {
    setExchangeSettings: (state, action: PayloadAction<IExchangeSettings | null>) => {
      state.settings = action.payload;
      const availableSigners = [];
      if (action.payload?.first_signatory_user) {
        availableSigners.push(action.payload?.first_signatory_user);
      }
      if (action.payload?.second_signatory_user) {
        availableSigners.push(action.payload?.second_signatory_user);
      }
      state.availableSigners = state.availableSigners.length > 0 ? state.availableSigners : availableSigners;
    },

    setIsSaveInitiated: (state, action: PayloadAction<number | null>) => {
      state.isSaveInitiated = action.payload;
    },

    setCompanyUsers: (state, action: PayloadAction<ICompanyUser[]>) => {
      state.companyUsers = action.payload;
    },

    setAvailableSigners: (state, action: PayloadAction<IExchangeSettingsUser[]>) => {
      state.availableSigners = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as ExchangeSettingsInitialState, action);
    });
  },
});
export const ExchangeSettingsAC = AC;

export const { setExchangeSettings, setIsSaveInitiated, setCompanyUsers, setAvailableSigners } =
  exchangeSettings.actions;
